<script>
import nl from "element-ui/src/locale/lang/nl";
import Form from "vform";
import Multiselect from "vue-multiselect";
import PlatformHelper from "../../helpers/platform";
import RequestListItem from "./RequestListItem.vue";

export default {
    name: "ServiceDeskBlock",
    components: {RequestListItem, Multiselect},
    data: () => ({
        isLoading: false,
        createVisible: false,
        createFields: {
            summary: null,
            message: null,
            files: null,
            platform_ids: [],
            platform_temp: [],
            user_ids: [],
            user_temp: [],
        },
        createForm: new Form,
        users: [],
        requests: [],
    }),
    mounted() {
        this.fetchRequests();
    },
    watch: {
        'createFields.platform_temp'() {
            this.createFields.user_temp = [];
            this.createFields.user_ids = [];
            this.fetchUsers();
        }
    },
    computed: {
        platform_select() {
            let select = [];
            this.$store.getters['auth/user'].allowed_platforms
                .forEach(function (item) {
                    select.push({
                        id: item.id,
                        title: item.name,
                    })
                });
            select = _.sortBy(select, ['title']);
            return select;
        },
        user_select() {
            let data = {};
            let platform_temp_ids = this.createFields.platform_temp.map(e => e.id);
            this.users.forEach(function (item) {
                if (!item.is_active) return;
                item.allowed_platforms.forEach(function (platform) {
                    if (platform_temp_ids.length && !platform_temp_ids.includes(platform.id)) return;
                    if (!data[platform.id]) data[platform.id] = {group_name: PlatformHelper.get(platform.id).name, users: []}
                    data[platform.id].users.push({
                        id: item.id,
                        title: item.name,
                    });
                })
            });
            data = _.mapValues(data, function (item) {
                item.users = _.sortBy(item.users, ['title'])
                return item;
            });
            return _.values(data);
        },
    },
    methods: {
        fetchRequests() {
            let self = this;
            self.isLoading = true;
            axios.get('/api/servicedesk')
                .then(r => {
                    self.requests = r.data;
                    self.isLoading = false;
                })
        },
        fetchUsers() {
            if (!this.createFields.platform_temp.length) {
                this.users = [];
                return;
            }
            let self = this;
            axios.get('/api/users', {
                params: {
                    platform_id: this.createFields.platform_temp.map(e => e.id),
                },
            })
                .then(response => {
                    self.users = response.data.data;
                });
        },
        uploadFile(e) {
            this.createFields.files = e.target.files;
        },
        createFieldsClear() {
            this.createFields = {
                summary: null,
                message: null,
                files: null,
                platform_ids: [],
                platform_temp: [],
                user_ids: [],
                user_temp: [],
            };
        },
        createRequest() {
            this.createForm = new Form({
                summary: this.createFields.summary,
                message: this.createFields.message,
                files: this.createFields.files,
                platform_ids: this.createFields.platform_temp.map(e => e.id),
                user_ids: this.createFields.user_temp.map(e => e.id),
            });

            let self = this;
            self.isLoading = true;
            self.createForm.post('/api/servicedesk')
                .then(r => {
                    self.createVisible = false;
                    self.createFieldsClear();
                    self.isLoading = false;
                    self.fetchRequests();
                    self.$message.success({
                        message: 'Заявка создана',
                        duration: 2000,
                    });
                })
        }
    }
}
</script>

<template>
    <div v-loading="isLoading">
        <button v-if="createVisible === false" class="btn btn-gray" @click.prevent="createVisible = true"><i class="fas fa-plus"></i> Создать заявку</button>
        <form name="createRequest" @submit.prevent="createRequest" v-if="createVisible">
            <div class="form-group">
                <label :for="'summary' + _uid">Тема</label>
                <input type="text" class="form-control" v-model="createFields.summary" required />
                <has-error :form="createForm" :field="'summary'" class="d-block"/>
            </div>
            <div class="form-group">
                <label :for="'message' + _uid">Описание</label>
                <textarea class="form-control" rows="3" v-model="createFields.message" required></textarea>
                <has-error :form="createForm" :field="'message'" class="d-block"/>
            </div>
            <div class="form-group">
                <div class="custom-file">
                    <input multiple type="file" name="files" class="custom-file-input" :id="'files' + _uid" lang="ru-RU" @change="uploadFile">
                    <label class="custom-file-label" :for="'files' + _uid">{{createFields.files ? 'Выбрано файлов: ' + createFields.files.length : 'Выберите файлы'}}</label>
                </div>
                <has-error :form="createForm" field="files"/>
            </div>
            <div class="form-group">
                <label :for="'platforms' + _uid">Площадки</label>
                <multiselect class="multiselect-bootstrap" :id="'platforms' + _uid" v-model="createFields.platform_temp" :options="platform_select" :multiple="true" :taggable="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="title" track-by="id" :selectedLabel="''" :placeholder="''" :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" />
                <has-error :form="createForm" field="platform_ids"/>
            </div>
            <div class="form-group">
                <label :for="'platforms' + _uid">Пользователи</label>
                <multiselect class="multiselect-bootstrap" :id="'users' + _uid" v-model="createFields.user_temp" tag-placeholder="" placeholder="" :options="user_select" :close-on-select="false" :clear-on-select="false" label="title" track-by="id" :multiple="true" :taggable="true" :selectedLabel="''" :placeholder="''" :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" :showNoOptions="false"  :searchable="true" group-values="users" group-label="group_name" :group-select="true" selectGroupLabel="Выбрать" deselectGroupLabel="Отменить"></multiselect>
                <has-error :form="createForm" field="platform_ids"/>
            </div>

            <div class="form-group">
                <button class="btn btn-primary" type="submit">Создать заявку</button>
                <button class="btn btn-gray" type="button" @click.prevent="createVisible = false">Отмена</button>
            </div>
        </form>
        <div class="mt-5">
            <RequestListItem @comment-added="fetchRequests" :request="r" v-for="r in requests" :key="r.id" />
        </div>
    </div>
</template>

<style scoped>

</style>